import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from '@src/app/services/bsModalService/bs-modal.service';

@Component({
  selector: 'app-paywall-icon-warning',
  templateUrl: './paywall-icon-warning.component.html',
  styleUrls: ['./paywall-icon-warning.component.scss']
})
export class PaywallIconWarningComponent implements OnInit {
  public Yiit = Yiit;
  public currentMessage: string;

  constructor(private bs: EsBsModalService) { }

  ngOnInit() {
    window['openPaywallIconObjectsModal'] = ()=>{
      this.bs.currentModal = '#paywall-icon-warning';
      this.bs.openModal();
    }
    this.currentMessage = window['PAYWALL_ICON_WARNING_MESSAGE'];
  }

  getPricingLink() {
    return 'https://www.oneplanevents.com/pricing/';
  }

  openUpgradeNowPopup() {
    this.bs.closeModal();
    this.bs.currentModal = '#update-now-popup';
    this.bs.openModal();
  }
}
